export default __webpack_public_path__ + "static/media/laza_m.a1a66177.jpg";